import { useCallback } from 'react'
import { NAMEPSACE } from '../components/Globals'

export const useReport = () => {
    const onReport = useCallback(async (imdb_id, video_id, reason) => {
        try {
            await fetch(NAMEPSACE + 'report', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ imdb_id, video_id, reason })
            })
        } catch (e) {
            // swallow error for now
        }
    }, [])

    return { onReport }
}


